// const minResolution = 1280;
const breakPoint = 1440;
const maxResolution = 1920;

const leftMenuFull = 240;
const leftMenuSmall = 64;
const layoutPaddings = 52;

const smallLayout = leftMenuSmall + layoutPaddings;
const largeLayout = leftMenuFull + layoutPaddings;

export const calcColumnShadow = (tableConf, screenWidth) => {
  const tableWidth = tableConf.reduce(function (accumulator, currentValue) {
    if (currentValue.show) return accumulator + currentValue.width;
    return accumulator;
  }, 16);

  if (
    (screenWidth <= breakPoint && tableWidth > screenWidth - smallLayout) ||
    (screenWidth > breakPoint &&
      screenWidth <= maxResolution &&
      tableWidth > screenWidth - largeLayout) ||
    (screenWidth > maxResolution && tableWidth > maxResolution - largeLayout)
  ) {
    return true;
  }
  return false;
};

export const whoIslast = (element, tableConf) => {
  let isLast = '';
  let curWidth = 0;
  let lastWidth = 0;
  tableConf.map(item => {
    if (item.show) {
      curWidth += item.width;
      if (
        curWidth - element.scrollLeft <= element.offsetWidth &&
        lastWidth - element.scrollLeft <= element.offsetWidth
      ) {
        isLast = item.title;
        lastWidth = curWidth;
      } else if (
        curWidth - element.scrollLeft > element.offsetWidth &&
        lastWidth - element.scrollLeft <= element.offsetWidth
      ) {
        isLast = item.title;
        lastWidth = curWidth;
      } else {
        lastWidth = curWidth;
      }
    }
    return false;
  });
  return isLast;
};
